"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoAporReason = void 0;
var NoAporReason;
(function (NoAporReason) {
    NoAporReason["notHomeSecured"] = "notHomeSecured";
    /** @deprecated it didn't account the scenario where we charge fees. Use NoAporReason.noNewDraw instead */
    NoAporReason["noNewBalanceBuilt"] = "noNewBalanceBuilt";
    NoAporReason["autoLoanRefinance"] = "autoLoanRefinance";
    NoAporReason["zeroAprForClosingChargeInstallmentLoan"] = "zeroAprForClosingChargeInstallmentLoan";
    NoAporReason["noNewDraw"] = "noNewDraw";
})(NoAporReason || (exports.NoAporReason = NoAporReason = {}));
